import uiRouter from '@uirouter/angularjs';
import { CartService, CartServiceModule } from '@b2b/common/services';
import angular from 'angular';

MembershipListCardholdersController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  '$uibModal',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'PermissionsService',
  'ThemesHelperService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'ViewStateService',
  'CartService',
  'FeatureToggleService',
  'MembershipService',
  'UserPreferencesService',
];

function MembershipListCardholdersController(
  $scope,
  $state,
  $timeout,
  $filter,
  $uibModal,
  ApiService,
  CalendarService,
  HelpersService,
  PermissionsService,
  ThemesHelperService,
  GridStateFactory,
  GridDefinitionFactory,
  ViewStateService,
  CartService: CartService,
  FeatureToggleService,
  MembershipService,
  UserPreferencesService
) {
  $scope.membershipListCardholders = {
    model: [],
    filtered: [],
    searchQuery: '',
    isLoaded: false,
    queryTimer: false,
    blockQuery: false,
    corporateSearch: false,
    searchCardType: '',
    viewId: '',
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
    membershipListCardholdersGridName: $state.current.name + '.cardholders.grid0',

    memberActions: [
      {
        name: 'renew',
        action: 'renewMembership',
        label: 'Quick Renew',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'renewOptions',
        action: 'renewMembershipWithOptions',
        label: 'Renew Options',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'upgradeDowngrade',
        action: 'upgradeDowngradeMembership',
        label: 'Upgrade/Downgrade',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'cancel',
        action: 'cancelMembership',
        label: 'Cancel',
        enabled: PermissionsService.check('MEMBERSHIP_SALES'),
      },
      {
        name: 'renewUnavailable',
        action: 'noop',
        label: 'No more actions available',
        enabled: !PermissionsService.check('MEMBERSHIP_SALES'),
      },
    ],

    optionsOverride: {
      rowHeight: 40,
      data: 'membershipListCardholders.filtered',
      useAccessibleGrid: true,
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize) {
          $scope.membershipListCardholders.onDataGridPaginate(newPageNumber, newPageSize);
        },
        onDataGridSortChange: function (grid, columns, page) {
          $scope.membershipListCardholders.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: function (item) {
          $scope.membershipListCardholders.onDblClick(item);
        },
        renewMembership: function (item) {
          $scope.membershipListCardholders.checkLifeCycle(item, null);
        },
        renewMembershipWithOptions: function (item) {
          $scope.membershipListCardholders.checkLifeCycle(item, 'renew');
        },
        upgradeDowngradeMembership: function (item) {
          $scope.membershipListCardholders.checkLifeCycle(item, 'upgradeDowngrade');
        },
        cancelMembership: function (item) {
          $scope.membershipListCardholders.cancelMembership(item);
        },
        transactAsMember: function (item) {
          $scope.membershipListCardholders.transactAsMember(item);
        },
        noop: function () {},
        memberActions: function () {
          return $scope.membershipListCardholders.memberActions;
        },
      },
      columnDefs: [
        {
          field: 'view',
          displayName: 'View',
          width: 50,
          onCellNavClick: function (row, col) {
            $scope.membershipListCardholders.optionsOverride.appScopeProvider.onDblClick(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'externalMembershipId',
          displayName: 'External Membership Id',
          headerTooltip: true,
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'membershipStanding',
          displayName: 'Membership Standing',
          headerTooltip: true,
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'name',
          displayName: 'Name on Card',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipCategory',
          displayName: 'ACME Level',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'firstName',
          displayName: 'First Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'email',
          displayName: 'Email',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'cardType',
          displayName: 'Card Type',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'streetAddress1',
          displayName: 'Address',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'city',
          displayName: 'City',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'state',
          displayName: 'State',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'zipCode',
          displayName: 'Zip',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipJoinedDateDisplay',
          displayName: 'Joined',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'membershipExpirationDateDisplay',
          displayName: 'Expires',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'category',
          displayName: 'Category',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'subcategory',
          displayName: 'Subcategory',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'barcode',
          displayName: 'External Barcode',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeBarcode',
          displayName: 'ACME Barcode',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeCustomerNumber',
          displayName: 'ACME Customer Number',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'acmeMembershipNumber',
          displayName: 'ACME Membership Number',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'constituentId',
          displayName: 'Constituent Id',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'externalConstituentId',
          displayName: 'External Constituent Id',
          headerTooltip: true,
          visible: false,
        },
      ],
    },

    allowUpgradeExternalMemberships: false,

    init: function () {
      this.viewId = $state.current.name;

      this.gridDefinition.init(
        this.membershipListCardholdersGridName,
        this.optionsOverride,
        this.viewId,
        $state.current.data.enablePreferences
      );

      this.restoreViewState();

      this.initGridColumns();

      this.initConfigData();

      $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);
      $scope.$on('MembershipListController::Search', this.onMembershipListControllerSearch);
      $scope.$on('MembershipListController::AdvancedSearch', this.onMembershipListControllerAdvancedSearch);

      $scope.$on('pageContent::startLoad', function (event, data) {
        const self = $scope.membershipListCardholders;

        if (data && data.from && data.from.name === 'application.membership.list') {
          switch (data.to.name) {
            case 'application.cart':
              self.updateState();
              break;
          }
        }
      });
    },

    initConfigData: function () {
      this.allowUpgradeExternalMemberships = ThemesHelperService.getCompany('allowUpgradeExternalMemberships');
    },

    initGridColumns: function () {
      if (ThemesHelperService.getCompany('auxiliaryMembership')) {
        this.optionsOverride.columnDefs.splice(
          3,
          0,
          {
            field: 'auxiliary',
            displayName: 'Is Aux',
            cellTemplate:
              '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">{{ row.entity.auxiliary ? "Yes" : "No" }}</span></a></div>',
            headerTooltip: true,
            visible: true,
          },
          {
            field: 'membershipLevelCollectionName',
            displayName: 'Auxiliary Group',
            headerTooltip: true,
            visible: true,
          }
        );
      }
      if (
        FeatureToggleService.check('TENANT_CART') &&
        PermissionsService.check(['ORDER_CREATE', 'ACCT_ORDERS_CREATE'])
      ) {
        this.optionsOverride.columnDefs.push({
          field: 'transact',
          displayName: 'Transact',
          width: 110,
          minWidth: 110,
          onCellNavClick: function (row, col) {
            $scope.membershipListCardholders.optionsOverride.appScopeProvider.transactAsMember(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()">' +
            '<div class="btn-group dropdown" uib-dropdown dropdown-append-to-body="true" data-ng-if="(row.entity.membershipStanding !==  \'new\')">' +
            '<button id="membership-list-dropdown-action" data-ng-click="grid.appScope.transactAsMember(row)" ' +
            'class="membership-list-dropdown-action btn btn-primary btn-xs">Transact<span class="sr-only"> as {{ row.entity.name }}</span> </button>' +
            '<button class="btn btn-primary btn-xs dropdown-toggle" uib-dropdown-toggle>' +
            '<span class="caret"></span>' +
            '<span class="sr-only"> Renew actions for {{ row.entity.name }}</span>' +
            '</button>' +
            '<ul class="dropdown-menu dropdown-menu-right membership-list-dropdown-action" uib-dropdown-menu role="menu" aria-labelledby="membership-list-dropdown-action">' +
            '<li role="menuitem" data-ng-if="memberAction.enabled" data-ng-repeat="memberAction in grid.appScope.memberActions()">' +
            '<a href class="font-small" data-ng-click="grid.appScope[memberAction.action](row)">' +
            '<span>{{ memberAction.label }}</span>' +
            '</a>' +
            '</li>' +
            '</ul>' +
            '</div>' +
            '</div>',
          visible: true,
          enableSorting: false,
        });
      }
    },

    updateState: function () {
      const state = {
        page: this.gridState.getPropertyValue('page'),
        pageSize: this.gridState.getPropertyValue('pageSize'),
        search: this.searchQuery,
      };

      ViewStateService.setState('membership.list', state);
    },

    restoreViewState: function () {
      const viewState = ViewStateService.getState('membership.list');

      if (viewState.page) {
        this.gridState.setPropertyValue('page', viewState.page);
        this.gridDefinition.setPageNumber(viewState.page);
        this.gridState.setPropertyValue('pageSize', viewState.pageSize);
      }

      if (viewState.search) {
        this.gridState.setPropertyValue('search', viewState.search);
      }
    },

    initData: function () {
      const self = $scope.membershipListCardholders;
      const props = self.gridDefinition.getGridState();

      self.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      self.setSearchMode('search');

      self.getMembers();
    },

    /**
     * @param {'search' | 'advancedSearch'} searchMode Determines which API is going to be used to get the memberships list
     */
    setSearchMode: function (searchMode) {
      const self = $scope.membershipListCardholders;

      self.gridState.setPropertyValue('searchMode', searchMode);
    },

    getMembers: function () {
      const self = $scope.membershipListCardholders;
      const props = Object.assign({}, self.gridState.getGridState());

      self.blockQuery = true;
      self.isLoaded = false;
      self.gridDefinition.isLoaded = false;

      $scope.$emit('MembershipList::Loaded', { isLoaded: self.gridDefinition.isLoaded });

      if (props.searchMode === 'advancedSearch') {
        ApiService.membership.summaries.advancedSearch(props).then(self.success.getMembers, self.error.getMembers);
      } else {
        props.corporate = self.corporateSearch;

        if (self.searchQuery && self.searchQuery.length) {
          props.cardType = self.searchCardType;
        }

        ApiService.membership.summaries.search(props).then(self.success.getMembers, self.error.getMembers);
      }
    },

    query: function () {
      const self = $scope.membershipListCardholders;

      self.gridState.setPropertyValue('search', this.searchQuery);

      if (this.queryTimer) {
        $timeout.cancel(this.queryTimer);
      }

      this.queryTimer = $timeout(function () {
        $scope.$broadcast('DataGrid::Search', { name: self.membershipListCardholdersGridName });
      }, 300);
    },

    search: function () {
      this.filtered = $filter('filter')(this.filtered, function (member) {
        const number = member.externalMembershipId || '';
        const name = member.name || '';
        const email = member.email || '';
        const value = (number + name + email).toLowerCase();
        console.log(
          'ProgramsController::search',
          member.name,
          $scope.membershipListCardholders.searchQuery,
          value.indexOf($scope.membershipListCardholders.searchQuery.toLowerCase()) !== -1
        );
        return value.indexOf($scope.membershipListCardholders.searchQuery.toLowerCase()) !== -1 ? member : null;
      });
    },

    process: function (members) {
      if (members instanceof Array) {
        for (let i = 0, ii = members.length; i < ii; i++) {
          members[i].membershipJoinedDateDisplay = $filter('date')(
            CalendarService.parseDate(members[i].membershipJoinedDate),
            this.dateFormat
          );
          members[i].membershipExpirationDateDisplay = $filter('date')(
            CalendarService.parseDate(members[i].membershipExpirationDate),
            this.dateFormat
          );
        }
      } else {
        members = [];
      }

      return members;
    },

    cancelMembership: function (item) {
      const self = $scope.membershipListCardholders;
      const membership = item.entity;

      ApiService.membership.eligibility
        .listByMembershipCategory({
          membershipId: item.entity.membershipId,
          saleChannels: 'insideSalesIndividual',
          actions: CartService.memberships.ENUMS['cancel'].join(),
          summarize: 0,
        })
        .then(function (response) {
          const canCancel = response.data.payload.canCancel;

          if (!canCancel) {
            return Promise.reject();
          }

          const organizationOrderInput = {
            memberships: [
              {
                itemType: 'MembershipCancel',
                membershipInfo: {
                  membershipId: membership.membershipId,
                  membershipOfferingId: membership.offeringId,
                  waiveBenefits: false,
                  pricePointId: membership.pricePointId,
                  notifyGiftRecipient: false,
                  isGift: membership.isGift,
                  membershipCategoryId: membership.categoryId,
                  membershipCards: [membership],
                },
              },
            ],
          };

          return ApiService.orders.checkout.charges(organizationOrderInput).then(function (response) {
            self.goToState(membership, 'application.membership.cancel');
          });
        })
        .catch(function () {
          self.showMessage({
            title: 'Membership is not eligible',
            message: ['The membership for', membership.name, 'is not eligible to cancel'].join(' '),
          });
        });
    },

    checkLifeCycle: function (item, type) {
      const self = $scope.membershipListCardholders;
      const isQuickRenew = !type;
      const lifecycleType = type || 'renew';

      CartService.memberships
        .lifecycle(CartService.memberships.ENUMS[lifecycleType], {
          membershipId: item.entity.membershipId,
          membershipCategory: item.entity.membershipCategory,
          membershipName: item.entity.name,
        })
        .then(function (response) {
          const allowUpgrade =
            !response.data.payload.hasOwnProperty('externalMembership') ||
            !response.data.payload.externalMembership ||
            (self.allowUpgradeExternalMemberships && response.data.payload.externalMembership);
          const found = CartService.memberships.hasPricepointMatch(item.entity, response.data.payload);

          if (isQuickRenew && found) {
            self.updateOrderContact(item.entity, function () {
              CartService.memberships
                .addToCart(
                  angular.extend(item.entity, {
                    itemType: MembershipService.getPurchaseType(found.type || 'renew'),
                    amount: found.pricepoint.price,
                    orderContactId: item.entity.customerId,
                  })
                )
                .then(self.success.renewMembership)
                .catch(self.error.checkLifeCycle);
            });
          } else {
            self.updateOrderContact(
              item.entity,
              function () {
                self.goToState(item.entity, 'application.membership.retail', lifecycleType);
              },
              lifecycleType,
              allowUpgrade
            );
          }
        })
        .catch(self.error.checkLifeCycle);
    },

    transactAsMember: function (item) {
      const self = $scope.membershipListCardholders;

      self.updateOrderContact(item.entity, function () {
        self.goToState(item.entity, 'application.programs.list');
      });
    },

    updateOrderContact: function (membership, callBack, lifecycleType, allowUpgrade) {
      const self = $scope.membershipListCardholders;
      const hasNewMembershipPurchase = !!CartService.memberships.hasNewMembership();
      const isUpgradeDowngrade = lifecycleType && lifecycleType === 'upgradeDowngrade';
      const hasMembershipsInCart = CartService.memberships.hasMemberships();
      const hasItemsInCart = !!CartService.getItems().length;
      const isOrderContact = CartService.isOrderContact(membership.customerId);

      const showPrompt =
        (CartService.hasOrderContact() && !isOrderContact) ||
        hasNewMembershipPurchase ||
        (isOrderContact && isUpgradeDowngrade && (hasMembershipsInCart || hasItemsInCart)) ||
        (isUpgradeDowngrade && !allowUpgrade);

      let title = 'Are you sure?';
      let message: string | null = null;
      let cancel = 'Cancel';
      let button = 'Continue';
      let hideButton = false;

      if (showPrompt) {
        if (hasNewMembershipPurchase) {
          message = 'Continuing will remove any memberships in the cart.';
        } else if (!membership.customerId) {
          message =
            'Do you want to change the transacting member from ' +
            HelpersService.getFullName(CartService.getOrderContact()) +
            '?' +
            '<br><br>Doing so will remove any memberships in the cart.';
        } else if (isUpgradeDowngrade && !allowUpgrade) {
          title = 'Membership not eligible';
          message =
            'This membership was created outside of ACME. You cannot Upgrade / Downgrade within ACME, due to your current configuration.';
          cancel = 'Close';
          hideButton = true;
        } else if (isOrderContact && isUpgradeDowngrade && hasMembershipsInCart) {
          message =
            'The cart already contains a membership for ' +
            HelpersService.getFullName(CartService.getOrderContact()) +
            '.' +
            ' <br><br>Adding this new membership will clear the current membership from the cart.';
          button = 'Update Cart';
        } else if (isOrderContact && isUpgradeDowngrade && hasItemsInCart) {
          message =
            'Please add membership and tickets separately. Once you Upgrade / Downgrade, tickets will reflect applicable benefits.';
          cancel = 'Buy Tickets First';
          button = 'Upgrade / Downgrade Membership First';
        } else {
          message =
            'Do you want to transact as ' +
            HelpersService.getFullName(membership) +
            ' instead of ' +
            HelpersService.getFullName(CartService.getOrderContact()) +
            '? ' +
            '<br><br>Doing so will remove any memberships in the cart.';
        }

        self
          .showMessage({
            title: 'Are you sure?',
            message: message,
            okText: button,
            cancelText: cancel,
            hideOkText: hideButton,
          })
          .then(function () {
            CartService.cancelCart().then(function () {
              self.updateContactAndProceed(membership, callBack);
            });
          })
          .catch(function () {
            // do nothing
          });
      } else {
        self.updateContactAndProceed(membership, callBack);
      }
    },

    updateContactAndProceed: function (membership, callBack) {
      CartService.memberships
        .updateOrderContact({
          membershipId: membership.membershipId,
          orderContactId: membership.customerId,
        })
        .then(callBack, this.error.updateContact);
    },

    goToState: function (membership, state, lifecycleType) {
      const props: {
        membershipId: any;
        orderContactId?: any;
        lifecycleType?: any;
      } = {
        membershipId: membership.membershipId,
      };

      this.updateState();

      if (membership.customerId) {
        props.orderContactId = membership.customerId;
      }

      if (lifecycleType) {
        props.lifecycleType = lifecycleType;
      }

      $state.go(state, props);
    },

    /**
     * @param {object} props
     * @param {string} props.title
     * @param {string} props.message
     * @param {string?} props.okText
     * @param {string?} props.cancelText
     * @returns {Promise<any>}
     */
    showMessage: function (props) {
      const self = $scope.membershipListCardholders;

      if (!props.message) {
        return Promise.resolve(undefined);
      }

      self.showMessageModal = $uibModal.open({
        templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
        size: 'md',
        controller: 'ConfirmCustomModalController',
        resolve: {
          modalTitle: function () {
            return props.title;
          },
          modalMessage: function () {
            return props.message;
          },
          okText: function () {
            return props.okText || 'Done';
          },
          cancelText: function () {
            return props.cancelText || 'Cancel';
          },
          hideOkText: function () {
            return !!props.hideOkText;
          },
        },
      });

      // Invoked when modal completes with close(params)
      return self.showMessageModal.result;
    },

    navigateToNewMembership: function () {
      const self = $scope.membershipListCardholders;
      const membership = CartService.getTransactingMembership();
      const orderContact = CartService.getOrderContact();

      const props = {
        membershipId: membership.id,
        customerId: orderContact?.customerId,
      };

      self.goToState(props, 'application.membership.retail');
    },

    showMembershipMessage: function () {
      const self = $scope.membershipListCardholders;
      const membership = CartService.getTransactingMembership();
      const orderContact = CartService.getOrderContact();
      const title = 'Proceeding will clear the cart';
      const message =
        HelpersService.getFullName(orderContact) +
        ' already has a membership: ' +
        membership.membershipCategory +
        ' (expiring ' +
        membership.membershipExpirationDateDisplay +
        '). Adding a new membership will remove the currently transacting member and clear contents of the cart.';

      self.showMessageModal = $uibModal.open({
        templateUrl: 'views/application/views/membership/list/modals/member/member.tpl.html',
        size: 'md',
        controller: 'MembershipListModalsMemberController',
        resolve: {
          modalTitle: function () {
            return title;
          },
          modalMessage: function () {
            return message;
          },
          showRenew: function () {
            return false;
          },
        },
      });

      self.showMessageModal.result.then(
        function (response) {
          const props = {
            membershipId: membership.id,
            customerId: orderContact?.customerId,
          };

          if (response === 'renew') {
            self.goToState(props, 'application.membership.retail');
          } else if (response === 'clear') {
            CartService.cancelCart().then(self.success.clearMember, self.success.clearMember);
          }
        },
        function (response) {
          // Close modal, do nothing
        }
      );
    },

    success: {
      init: function (response) {},
      getMembers: function (response) {
        const self = $scope.membershipListCardholders;

        self.filtered = self.process(response.data.payload.list);

        self.isLoaded = true;
        self.gridDefinition.isLoaded = true;
        self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);

        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.filtered.length,
            totalItems: self.gridState.getPropertyValue('totalItems'),
          });

          $scope.$emit('MembershipList::Loaded', { isLoaded: self.gridDefinition.isLoaded });

          $timeout(function () {
            self.blockQuery = false;
          }, 100);
        }, 10);
      },

      renewMembership: function (response) {
        $scope.$emit('Cart::Open', {
          itemName: MembershipService.getLifeCycleLabel(MembershipService.getPurchaseType('renew')),
        });
      },
      clearMember: function (response) {
        $scope.$emit('Cart::Close');
        $state.go('application.membership.retail');
      },
    },

    error: {
      init: function (response) {},
      getMembers: function (response) {
        $scope.$emit('MembershipList::Error', { response: response });
      },
      getMembershipEligibility: function () {
        $scope.membershipListCardholders.showMessage({
          title: 'An error occurred',
          message: 'Unable to retrieve eligible sales actions for this membership.',
        });
      },
      checkLifeCycle: function (response) {
        $scope.membershipListCardholders.showMessage({ title: response.data.title, message: response.data.error });
      },
      updateContact: function (response) {
        $scope.membershipListCardholders.showMessage({ title: 'An error occurred', message: response.data.error });
      },
      clearMember: function (response) {
        $scope.membershipListCardholders.showMessage({ title: 'An error occurred', message: response.data.error });
      },
    },

    onDataGridSortChange: function (grid, columns, page) {
      const self = $scope.membershipListCardholders;
      const data = columns[0];

      if (data) {
        if (!self.blockQuery) {
          self.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
          self.getMembers();
        } else {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.filtered.length,
            totalItems: self.gridState.getPropertyValue('totalItems'),
          });
        }
      }
    },

    onDblClick: function (item) {
      // Create and edit are handled by the same controller
      this.updateState();
      console.log('MembershipListController::onGridDblClick', item.entity.membershipId);
      $state.go('application.membership.detail', { id: item.entity.membershipId, searchName: item.entity.name });
    },

    onDataGridPaginate: function (newPage, pageSize) {
      const self = $scope.membershipListCardholders;

      if (!self.blockQuery) {
        self.gridState.updateGridState(newPage, pageSize);
        self.getMembers();
      } else {
        $scope.$broadcast('DataGrid::ResizeGrid', {
          name: self.gridDefinition.options.gridName,
          datasetLength: self.filtered.length,
          totalItems: self.gridState.getPropertyValue('totalItems'),
        });
      }
    },

    onDestroy: function () {
      if ($scope.membershipListCardholders.queryTimer) {
        $timeout.cancel($scope.membershipListCardholders.queryTimer);
      }
    },

    onMembershipListControllerSearch: function (e, data) {
      const self = $scope.membershipListCardholders;
      self.searchQuery = data.searchQuery;
      self.gridState.setPropertyValue('search', self.searchQuery);
      self.setSearchMode('search');

      if (data.searchType === 'organizations' && data.searchCardholders) {
        self.corporateSearch = true;
        self.searchCardType = 'primary';
        self.getMembers();
      } else if (data.searchType === 'individual') {
        self.corporateSearch = false;
        self.getMembers();
      }
    },

    /**
     *
     * @param {*} e
     * @param {{ filters: Record<string, string>}} data
     */
    onMembershipListControllerAdvancedSearch: function (e, data) {
      const self = $scope.membershipListCardholders;

      // Reset basic search properties
      self.searchQuery = '';
      self.gridState.setPropertyValue('search', self.searchQuery);
      self.corporateSearch = false;

      const validAdvancedFilters = ['firstName', 'lastName', 'address', 'zip', 'email', 'memberId', 'cardName'];

      validAdvancedFilters.forEach(function (key) {
        const value = data.filters[key] || '';
        self.gridState.setPropertyValue(key, value);
      });
      self.setSearchMode('advancedSearch');

      self.getMembers();
    },
  };

  $scope.membershipListCardholders.init();
}

export const MembershipListCardholdersControllerModule = angular
  .module('acme.view.application.membership.list.cardholders.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.membership',
    'acme.common.service.featureToggle',
    'acme.common.service.themesHelper',
    'acme.common.service.viewState',
    CartServiceModule,
    'acme.common.service.userPreferences',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.view.application.modals.confirm.controllers',
    'acme.view.application.modals.confirmCustom.controllers',
    'acme.view.application.membership.list.modals.member.controllers',
  ])
  .controller('MembershipListCardholdersController', MembershipListCardholdersController).name;
